<template>
    <div class="pa-t-40 bg-round bg-fff">
        <div class="container">
            <Bread/>
            <!-- <header id="header">
                <div class="flex f-around">
                    <div class="header-li header-active" @click="toPage('/competition/short')">短片奖（Short Film Award）</div>
                    <div class="header-li" @click="toPage('/competition/scenario')">剧本大赛（Script）</div>
                    <div class="header-li" @click="toPage('/plan/media')">创作扶持（Creation）</div>
                    <div class="header-li" @click="toPage('/competition/winner')">获奖作品（Winners）</div>
                    <div class="header-li" @click="toPage('/merge/Activity')">展映活动（Exhibition）</div>
                </div>
            </header> -->
        </div>

        <div class="container line-height-35 main-md " id="app">
            <div v-html="detail.Content" class="ma-t-20 vhtml"></div>
        </div>

        <div class="img-a-bg" v-if="detail.Content">
            <img src="../../img/merge/i2.png" alt="" srcset="" class="img-logo c-pointer">
        </div>

    </div>
</template>
<style lang="scss" scoped>
    @import "../../../css/bootstrap.min.css";
    @import "../../../css/commons.css";

   .img-person {
        width: 220px;
    }
    @media (min-width: 768px) {
        // .header-li {
        //     margin-right: 40px;
        // }
        .main-md{
            margin: 0 auto;
            width: 680px;
        }
    }
    @media (max-width:768px) {
        .img-a-bg{
            display:none;
        }
    }

    .img-a-bg {
        width: 100%;
        height: 285px;
        background: url('../../img/merge/cp11.png') no-repeat;
        background-size: cover;
        background-position: center center;
        text-align: right;
        line-height: 285px;
    }

    .img-logo {
        width: 206px;
        height: 206px;
        margin-right: 40px;
    }
    .vhtml img{max-width: 100%;}
</style>
<script>
    import {getOther} from "../../api.js";
    export default {
        name: "merge",
        data() {
            return {
                detail:"",
                Content:"",
                footbottom:123,
            };
        },
        created() {
           console.log("开始开发")
           this.getDetail();
        },
        
        methods: {
            //跳转链接
            toBanerHref() {
                let i = this.$refs.carousel.activeIndex;
                let item = this.bannerlist[i];
                console.log(item);
                if (!item.Href) {
                    return;
                } else {
                    location.href = item.Href;
                }
            },
            //获取数据
            getDetail() {
                let data = {
                    code: "competition.short",
                };
                getOther(data).then((res) => {
                    console.log(res);
                    this.detail = res.data.Data;
                    // this.Content=res.data.Data.Content.replace(/<img/g,"<img mode='widthFix' style='width: 100%;vertical-align: middle;height: auto;'");
                });
            },
            toPage(url){
                this.$router.push(url);
            }
        },
    };
</script>
